import React, { useEffect, useState, useRef } from 'react';
import {
  IconButton,
  InputGroup,
  InputLeftElement,
  Tooltip,
  useColorModeValue,
} from '@chakra-ui/react';
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
  TableInstance,
} from 'react-table';
import { Navigate, useNavigate } from 'react-router-dom';
import SelectField from 'components/fields/SelectField';
import { SearchIcon } from '@chakra-ui/icons';
import { HashLoader } from 'react-spinners';

// Chakra imports
import {
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Box,
  Button,
  FormControl,
  SimpleGrid,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import {
  getCreatorName,
  getCompanyList,
  getSelectCreator,
} from 'utils/creatorActivity/CreatorActivity';

type RowObj = {
  id: number;
  sNo: number;
  CreatorName: string;
  CreatorEmail: any;
  companyNamess: string;
  createdUserId: number;
  company: number;
  nooflearners: number;
  Downloads: any;
  noofgamespublished: number;
  noofgameslaunched: number;
  noofdownloads: number;
  noofgames: number;
  timeSpent: any;

  LastActiveDate: string;

  plan: string;
  validity: string;
};
interface CreatorActivityData {
  id: number;
  name: string;
  createdUserId: number | null;
  company: number;
  CreatorName: string;
  CreatorEmail: any;
  companyNamess: string;
  // status: string;
  nooflearners: number;
  noofdownloads: number;
  Downloads: any;
  noofgamespublished: number;
  noofgameslaunched: number;
  noofgames: number;
  timeSpent: any;
  LastActiveDate: string;
}

interface ColumnObj {
  Header: number | string;
  accessor: keyof RowObj;
}
interface OptionType {
  value: string;
  label: string;
}
interface CreatorActivityDataTableProps {
  data: RowObj[];
}

interface creatorType {
  ctName: string;
  ctId: string;
  // other properties if any
}
type DataCol = TableInstance<RowObj>;
interface CustomCreatorDataTableProps {
  data: RowObj[];
  setApiData: React.Dispatch<React.SetStateAction<CreatorActivityData[]>>;
  setCompany: any;
  setCreator: any;
  // Other props as needed
}
const CreatorActivityDataTable: React.FC<CustomCreatorDataTableProps> = ({
  data,
  setApiData,
  setCompany,
  setCreator,
}) => {
  const storage = JSON.parse(localStorage.getItem('user'));

  let storageCreatorId = '';
  const UserRole = storage.data.role;
  if (storage.data.role === 'Creator') {
    storageCreatorId = storage.data.id;
  }
  interface OptionTypecon {
    value: string;
    label: string;
    CompanyId: string;
  }
  const [lastPage, setLastPage] = useState<any>();
  const [companyOptions, setCompanyOptions] = useState([]);
  const [CreatorOptions, setCreatorOptions] = useState([]);
  const [localPageIndex, setLocalPageIndex] = useState(0);
  const [localPageSize, setLocalPageSize] = useState(10);
  const [loadingdata, setLoadingdata] = useState(false);
  const [selected, setSelected] = useState({
    companyId: '',
    creatorId: '',
  });
  const [creator, setcreator] = useState<creatorType[]>([]);
  const navigate = useNavigate();

  const mappedPlanOptions = Array.isArray(creator)
    ? creator.map((creator) => ({
        value: creator.ctId, // Convert to string if necessary
        label: creator.ctName,
      }))
    : [];
  const options: OptionType[] = [
    { value: 'Days', label: 'Days' },
    { value: 'Month', label: 'Month' },
    { value: 'Year', label: 'Year' },
  ];
  const searchIconColor = useColorModeValue('gray.700', 'white');
  let menuBg = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  const columns: ColumnObj[] = React.useMemo(
    () => [
      { Header: 'S.No', accessor: 'sNo' },
      { Header: 'Company', accessor: 'companyNamess' },
      { Header: 'Creator', accessor: 'CreatorName' },
      { Header: 'Email', accessor: 'CreatorEmail' },
      { Header: 'Creations', accessor: 'noofgames' },
      { Header: 'Launches', accessor: 'noofgameslaunched' },
      { Header: 'Downloads', accessor: 'noofdownloads' },

      { Header: 'Published', accessor: 'noofgamespublished' },
      { Header: 'Learners', accessor: 'nooflearners' },
      { Header: 'Time Spent', accessor: 'timeSpent' },
      { Header: 'Last Active ', accessor: 'LastActiveDate' },
    ],
    [],
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
    gotoPage,
    setPageSize,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
  }: DataCol = useTable<RowObj>(
    {
      columns,
      data: data,
      initialState: { pageIndex: localPageIndex, pageSize: localPageSize },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    const lastPage = Math.floor(data.length / pageSize);
    setLastPage(Math.floor(data.length / pageSize));
  }, []);

  const totalPages = Math.ceil(data.length / pageSize);

  useEffect(() => {
    setLocalPageIndex(pageIndex);
  }, [pageIndex]); // Ensure to sync whenever pageIndex changes

  // Update the handleGoPage function
  const handleGoPage = (pageNumber: number) => {
    // Ensure the page number is within valid range
    if (pageNumber >= 0 && pageNumber < totalPages) {
      gotoPage(pageNumber); // Let react-table handle the page change
    }
  };

  // Update the previous and next page logic
  const handlePageChange = (action: 'previous' | 'next') => {
    if (action === 'next' && canNextPage) {
      nextPage();
    } else if (action === 'previous' && canPreviousPage) {
      previousPage();
    }
  };
  const getPageNumbers = () => {
    const pageCount = 3; // Adjust the number of visible page numbers as needed
    const currentPage = pageIndex + 1;
    const pages = [];

    if (totalPages <= pageCount) {
      // Display all pages if total pages are less than or equal to the page count
      for (let i = 0; i < totalPages; i++) {
        pages.push(i + 1);
      }
    } else {
      // Display a range of pages with three dots in between
      const start = Math.max(1, currentPage - Math.floor(pageCount / 2));
      const end = Math.min(totalPages, start + pageCount - 1);

      if (start > 1) {
        pages.push(1, '...'); // Display first page and three dots if not in the initial range
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (end < totalPages) {
        pages.push('...', totalPages); // Display three dots and last page if not in the final range
      }
    }

    return pages;
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company = await getCompanyList();
        if (company?.status !== 'Success')
          return console.log('getCompanylist Error :', company?.message);
        setCompanyOptions(company?.data);
        setCompany(company?.data);
        const creator = await getSelectCreator(); // Replace with your actual function to get plan names
        if (creator?.status !== 'Success')
          return console.log('getPlanNames Error:', creator?.message);
        setCreatorOptions(creator?.data);
        setCreator(creator?.data);
        if (storage.data.role === 'Creator') {
          const selectCreatorData: OptionTypecon[] = creator?.data || [];
          const foundItem = selectCreatorData.find(
            (item) => item.value === storageCreatorId,
          );
          setSelected({ ...selected, companyId: foundItem?.CompanyId });
        }
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const handleCompanyChange = (selectedOption: OptionType | null) => {
    setSelected({
      ...selected,

      companyId: selectedOption.value ?? '',
      creatorId: '',
    });
  };
  const handleCreatorIdChange = (selectedOption: OptionTypecon | null) => {
    if (selectedOption) {
      setSelected({
        ...selected,
        creatorId: selectedOption.value ?? '',
        companyId: selectedOption.CompanyId ?? '',
      });
    } else {
      // Handle the case where selectedOption is null if needed
    }
  };

  const handleClick = async () => {
    setLoadingdata(true); // Start loading

    let data = JSON.stringify(selected);

    try {
      const result = await getCreatorName(data);

      if (result?.status !== 'Success') {
        setApiData([]);
        return;
      }

      setApiData(result?.data);
    } catch (error) {
      console.log('Fetch Data Error: ', error);
      setApiData([]);
    } finally {
      setLoadingdata(false);
    }
  };

  const handleNoOfGameClick = (creatorId: number) => {
    window.open(
      `/Noofgame/${creatorId}`, // Replace with your desired URL or route /gameAnswer/:id
      'PrintGamesList',
      'width=800,height=600',
    );
  };
  const handleNoOfGameLaunchedClick = (creatorId: number) => {
    window.open(
      `/Noofgamelaunch/${creatorId}`, // Replace with your desired URL or route /gameAnswer/:id
      'PrintGamesList',
      'width=800,height=600',
    );
  };
  const handleNoOfGamePublishedClick = (creatorId: number) => {
    window.open(
      `/Noofgamepublish/${creatorId}`, // Replace with your desired URL or route /gameAnswer/:id
      'PrintGamesList',
      'width=800,height=600',
    );
  };
  const handleNoOfLearnersClick = (id: number) => {
    window.open(
      `/learnerDetails/${id}`,
      'PrintLearnerDetails',
      'width=800,height=600',
    );
  };
  useEffect(() => {
    handleClick();
  }, [selected.companyId, selected.creatorId]);

  const [isHovering, setIsHovering] = useState(false);
  const tableRef = useRef<HTMLDivElement | null>(null);

  // Prevent scrolling of body when mouse is inside table
  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      if (isHovering && tableRef.current) {
        // Prevent vertical scroll on body
        if (e.deltaY !== 0) {
          e.preventDefault();
          // Scroll horizontally based on vertical scroll movement
          tableRef.current.scrollLeft += e.deltaY;
        }
      }
    };

    // Add event listener for scroll on window
    if (isHovering) {
      window.addEventListener('wheel', handleWheel, { passive: false });
    } else {
      window.removeEventListener('wheel', handleWheel);
    }

    return () => {
      // Cleanup the event listener
      window.removeEventListener('wheel', handleWheel);
    };
  }, [isHovering]);
  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };
  return (
    <>
      {loadingdata && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <Card mt={'20px'} width={'100%'}>
        <SimpleGrid columns={{ base: 1, md: 3, lg: 3 }} spacing={6}>
          <SelectField
            mb="0px"
            id="ctCompanyId"
            name="companyId"
            label="Company Name"
            options={companyOptions}
            isClearable={true}
            onChange={handleCompanyChange}
            value={
              companyOptions.find(
                (option) => option.value === selected.companyId,
              ) || null
            }
            isDisabled={storage.data.role === 'Creator'}
          />
          <SelectField
            mb="0px"
            id="ctId"
            name="creatorId"
            label="Creator Name"
            options={
              selected.companyId
                ? CreatorOptions.filter(
                    (option: any) => option.CompanyId === selected.companyId,
                  )
                : CreatorOptions
            }
            onChange={handleCreatorIdChange}
            value={
              CreatorOptions.find(
                (option) => option.value === selected.creatorId,
              ) || null
            }
          />
        </SimpleGrid>
      </Card>
      <Flex
        justifyContent="flex-end"
        align={'center'}
        mb={'10px'}
        p={{ sm: '20px 0px', md: '20px' }}
      >
        <Flex>
          <InputGroup w={{ base: '100%', sm: '100%', md: '200px' }}>
            <InputLeftElement
              children={
                <IconButton
                  aria-label="search"
                  bg="inherit"
                  borderRadius="inherit"
                  _active={{
                    bg: 'inherit',
                    transform: 'none',
                    borderColor: 'transparent',
                  }}
                  _hover={{
                    background: 'none',
                  }}
                  _focus={{
                    background: 'none',
                    boxShadow: 'none',
                  }}
                  icon={
                    <SearchIcon color={searchIconColor} w="15px" h="15px" />
                  }
                />
              }
            />
            <Input
              type="text"
              placeholder="Search..."
              value={globalFilter || ''}
              onChange={(e) => setGlobalFilter(e.target.value)}
              bg={'#f9f9f9'}
              borderRadius={'14px'}
              w={{ base: '100%', sm: '100%', xl: '300px' }}
            />
          </InputGroup>
        </Flex>
      </Flex>

      <Box
        ref={tableRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        overflowX="auto"
        overflowY={isHovering ? 'hidden' : 'scroll'} // Disable vertical scroll when inside table
        padding="2px"
        borderRadius={'13px 13px 20px 20px'}
      >
        <Table
          {...getTableProps()}
          variant={'simple'}
          overflowX={{ base: 'auto', xl: 'scroll' }}
          style={{
            border: '2px solid #f7f7f7',
          }}
        >
          <Thead className="thead" bg={'#f9f9f9'}>
            {headerGroups.map((headerGroup) => (
              <Tr
                {...headerGroup.getHeaderGroupProps()}
                borderBottom={'2px solid #f7f7f7'}
              >
                {headerGroup.headers.map((column) => (
                  <Th
                    whiteSpace={'nowrap'}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    color={'#191919'}
                    textAlign={'start'}
                    // p={'10px 10px'}
                  >
                    {column.render('Header')}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? ' 🔽'
                          : ' 🔼'
                        : ''}
                    </span>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()} fontSize={'17px'}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <Tr
                  {...row.getRowProps()}
                  borderBottom={'2px solid #f7f7f7'}
                  _hover={{ bg: '#FAF9F6' }}
                  cursor={'pointer'}
                >
                  {row.cells.map((cell) => {
                    return (
                      <Td
                        whiteSpace={'nowrap'}
                        {...cell.getCellProps()}
                        // p={'12px'}
                        textAlign={'start'}
                        onClick={() => {
                          if (cell.column.id === 'noofgames') {
                            handleNoOfGameClick(row.original.id);
                          } else if (cell.column.id === 'noofgameslaunched') {
                            handleNoOfGameLaunchedClick(row.original.id);
                          } else if (cell.column.id === 'noofgamespublished') {
                            handleNoOfGamePublishedClick(row.original.id);
                          } else if (cell.column.id === 'nooflearners') {
                            handleNoOfLearnersClick(row.original.id);
                          }
                        }}
                      >
                        {' '}
                        {cell.render('Cell')}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
        {/* </Box> */}
      </Box>
      <Box
        pt={'20px 5px'}
        display={{ base: 'block', xl: 'flex' }}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Box mb={5}>
          <Box mr={'10px'} color={'#000'}>
            <span style={{ color: '#20212396' }}>
              Page{' '}
              <span>
                {pageIndex + 1} of {Math.ceil(data.length / pageSize)}
              </span>{' '}
            </span>
          </Box>
        </Box>
        <Box display={{ base: 'flex', xl: 'flex' }}>
          <Box mr={'10px'} display={'flex'} alignItems={'center'}>
            <Button
              onClick={() => handlePageChange('previous')}
              disabled={!canPreviousPage}
              bg={'#f3f0f0'}
              mr={'5px'}
              h={'40px'}
              w={'40px'}
              borderRadius="50%"
              lineHeight="1em"
              flexShrink={0}
              fontWeight={800}
            >
              {'<'}
            </Button>{' '}
            {getPageNumbers().map((page, index) => (
              <Button
                key={index}
                h={'40px'}
                w={'40px'}
                mr={'5px'}
                borderRadius="100px"
                lineHeight="1em"
                flexShrink={0}
                fontWeight={800}
                background={pageIndex + 1 === page ? '#3311db' : 'unset'}
                color={pageIndex + 1 === page ? '#fff' : 'unset'}
                onClick={() =>
                  typeof page === 'number' ? handleGoPage(page - 1) : null
                }
              >
                {page}
              </Button>
            ))}
            <Button
              onClick={() => handlePageChange('next')}
              disabled={!canNextPage}
              bg={'#f3f0f0'}
              h={'40px'}
              w={'40px'}
              borderRadius="100px"
              lineHeight="1em"
              flexShrink={0}
              fontWeight={800}
            >
              {'>'}
            </Button>{' '}
          </Box>
          <Box></Box>
        </Box>
      </Box>
    </>
  );
};

export default CreatorActivityDataTable;
